import React, { memo } from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { notification } from 'antd';

const CopyLine = ({ text }: { text: string }) => {
  const [_, url] = text.split(/:(.+)/);

  return (
    <div className="subscription-container">
      <pre style={{ minHeight: '24px', marginBottom: '8px' }}>
        {text}
      </pre>
      <button
        className="subscription-button"
        type="button"
        onClick={() => {
          navigator.clipboard.writeText(url.trim());
          notification.success({
            message: 'Copied!',
          });
        }}
      >
        <CopyOutlined />
      </button>
    </div>
  );
};

export default memo(CopyLine);
